import { VideoSourcesScreen } from "./video-sources.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const VideoSourcesRoutes: RouteDefinition[] = [
	{
		path: Paths.videoSources.path,
		element: <VideoSourcesScreen />,
		requiredPermissions: ["UserInAccountPermission_VimeoVideoSourceAdmin_Read"],
	},
];
